import LessonBar from '@/components/_deprecated/lessons/LessonBar/LessonBar';
import Lesson from '@/models/Lesson';
import ScheduledLesson from '@/models/ScheduledLesson';
import { useTranslation } from 'react-i18next';

type Props = {
  index: number;
  scheduledLesson: ScheduledLesson;
};

export default function InvalidLesson({ index, scheduledLesson }: Props) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'invalidLesson',
  });

  return (
    <LessonBar
      blocked
      blockedMessage={t('warning')}
      lesson={
        new Lesson({
          id: scheduledLesson.lesson.id,
          name: t('title'),
        })
      }
      scheduledLesson={scheduledLesson}
      index={index}
    />
  );
}
